module.exports = __webpack_public_path__ + "static/media/trainerAndClient.18c364a2.png";